module.exports = __webpack_public_path__ + "img/ifo_logo_3.081be25b.png";